import { Action } from 'redux';

export enum ActionType {
  ToggleErrors = 'Validation.ToggleErrors',
  ClearErrors = 'Validation.ClearValidation',
}

export interface IValidationPayload {
  errors: Array<string>;
}

export interface IValidationAction extends Action<ActionType> {
  payload?: IValidationPayload;
  key: string;
}

export interface IValidationState {
  errors: Array<string>;
  invalid: boolean;
  cleared: boolean;
}

export interface IState {
  [key: string]: IValidationState;
}

const INITIAL_STATE: IState = {};

export default (state: IState = INITIAL_STATE, action: IValidationAction) => {
  switch (action.type) {
    case ActionType.ToggleErrors:
      return {
        ...state,
        [action.key]: {
          errors: action.payload.errors,
          invalid: !!action.payload.errors.length,
          cleared: false,
        },
      };
    case ActionType.ClearErrors:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          errors: [],
          invalid: false,
          cleared: true,
        },
      };
    default:
      return state;
  }
};

export const setValidation = (key: string, errors: Array<string>): IValidationAction => ({
  type: ActionType.ToggleErrors,
  key,
  payload: {
    errors,
  },
});

export const clearValidation = (key: string): IValidationAction => ({
  type: ActionType.ClearErrors,
  key,
});

export const selectValidation = (key: string, state: IState): IValidationState => ({
  ...(state[key] ? state[key] : {
    errors: [],
    invalid: false,
    cleared: false,
  }),
});
